// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const rolePlatformAdmin = {
  id: "platform-admin",
  mrn: "//iam.api.mondoo.app/roles/platform-admin",
  title: "Platform Admin",
  allowedActions,
} as const;

export type RolePlatformAdmin = typeof rolePlatformAdmin;
